module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/mobilestation1_317c16846ce3ef1f52499666b42d7ed1.png";